
// TODOS
// - Gulp
// - Prevent crash server hapi!
// - Log d'erreur? Graylog!

// http://l-pperron:8061/?roomid=1ac163b9-14b3-4dda-a184-3287f6d8b798&outurl=https%3A%2F%2Fwww.reservatech.net%2FSelectTickets.aspx%3FEventDateId%3D36984

// 1ac163b9-14b3-4dda-a184-3287f6d8b798 General Process Room
// 290f61cc-5577-4f53-8f02-b512b49437b8 GMG Process Room
// 13bc4b5b-25fa-428d-89f0-c3f830fe9553 SAM Process Room

// http://l-pperron:8061/?roomid=1ac163b9-14b3-4dda-a184-3287f6d8b798&personid=6b4ac6c9-c750-4ed3-a44b-4da0d3499099

var React = require('react');
var axios = require('axios');
var PT = require('prop-types');
var URI = require('urijs');
var cIf = require('classnames');
var animjs = require('peter-anim-js');

// Server person status
// NOT NEEDED YET const PERSON_STATUS_WAITING = 'WAITING';
const PERSON_STATUS_TRANSFERED = 'TRANSFERED';


const DEFAULT_CHECK_INTERVAL_MS = 10 * 1000;
const ERROR_CHECK_INTERVAL_MS = 30 * 1000; // This is used to slow things down in case the server went wrong.




// This is a wrapper around WaitingRoomControl that reads the URL param
// so the html web page as nothing to do. This app does everything
// If you want to pass your own params, use WaitingRoomControl.


// The "logical" control
export class WaitingRoomLogicControl extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            checkingStatus: false,
            timeToRedirect: false,
            showStillActiveReminder: false,
            checkIntervalMS: DEFAULT_CHECK_INTERVAL_MS, // Default 10 seconds, adjustable by the server
            lastMotivatingInfoDate: new Date(),
            progressPercentage: 0.0
        };
    }
    
    componentDidMount() {
        this.ajaxCancelToken = axios.CancelToken.source();
        this.checkStatus(); // Start the machine!
        this.stillActiveInterval = setInterval(function() { this.showStillActive(); }.bind(this), 1 * 60 * 1000);
    }


    componentWillUnmount() {
        if(this.checkTimer) clearTimeout(this.checkTimer);
        if(this.stillActiveInterval) clearInterval(this.stillActiveInterval);
        if(this.hideStillActiveTimeout) clearTimeout(this.hideStillActiveTimeout);
        
        this.ajaxCancelToken.cancel();

        // Stop timer
        // Stop ajax
    }

    showStillActive() {
        this.setState({ showStillActiveReminder: true });
        this.hideStillActiveTimeout = setTimeout(function() { this.setState({ showStillActiveReminder: false }); }.bind(this), 8 * 1000);
    }

    buildURL(relativeUrl) {
        if(this.props.roomServerUrl != null && this.props.roomServerUrl.length > 0)
            return URI(this.props.roomServerUrl + "/" + relativeUrl).normalizePathname();
        else
            return relativeUrl;
    }

    
    checkStatus() {
        this.setState({ checkingStatus: true });

        // This ourURL in there is for informative purposes on server side.
        this.checkQuery = axios.get(this.buildURL('rooms/' + this.props.roomId + '/people/' + this.props.personId + '/status?outurl=' + encodeURIComponent(this.props.outUrl)), { timeout: 7000, cancelToken: this.ajaxCancelToken.token });

        this.checkQuery.then((statusResp) => {
            this.setState({ checkingStatus: false });
            
            var response = statusResp.data;
            if(response.status != null) // If no error while getting the status (backend error for instance)
                this.updateStateFromPersonStatus(response.status); // Update things

            // Update the check interval
            this.setState({ checkIntervalMS: response.info.checkLoopWaitMs });

            this.checkTimer = setTimeout(() => { this.checkStatus() }, response.info.checkLoopWaitMs);
            
        }, (err) => {
            if(!axios.isCancel(err)){
                this.setState({ checkingStatus: false });

                // Take the longest interval of two because the server could tell us to wait a little longer...
                var checkIntervalTimeMS = ERROR_CHECK_INTERVAL_MS > this.state.checkIntervalMS ? ERROR_CHECK_INTERVAL_MS : this.state.checkIntervalMS;
                this.checkTimer = setTimeout(() => { this.checkStatus() }, checkIntervalTimeMS);
            } else { console.log("cancellll");}
        });
    }

    updateStateFromPersonStatus(status) {
        this.setState({ progressPercentage: status.progressPercentage });
        if(status.status === PERSON_STATUS_TRANSFERED) {
            if(this.props.personIsReadyToGo !== undefined && this.props.personIsReadyToGo !== null)
                this.props.personIsReadyToGo(this.props.personId);
        }
    }

    render() {
        var View = this.props.view;
        
        return (
            <View
                {...this.props}
                showStillActiveReminder={this.state.showStillActiveReminder}
                checkingStatus={this.state.checkingStatus}
                progressPercentage={this.state.progressPercentage}
            />
        );
    }
}

WaitingRoomLogicControl.propTypes = {
    roomId: PT.string.isRequired,
    personId: PT.string.isRequired,
    outUrl: PT.string,
    roomServerUrl: PT.string, // Specify this if it's not on the same site. Else, it'll be relative paths
    organizationName: PT.string,
    productName: PT.string,
    lang: PT.string,
    showMotivationMessageIntervalMS: PT.number,
    personIsReadyToGo: PT.func // func(personID)
};

WaitingRoomLogicControl.defaultProps = {
    organizationName: "Reservatech.net",
    productName: null,
    showMotivationMessageIntervalMS: 60 * 1000, // Each minute
    readyToGo: false // This help to change the message on screen when ready to go
};






var decay = 10;
var decal = 0.3;

// Functions that change the rate according to the distance
var decayF = (x) => 1 / ((x + decal) / decay);
// NOT USED YET: var decayFx = (x) => x / decayF(x);

var fadeOutFunc = (x) => -x + 1;
var fadeOut = (x) => x < 0 ? 1 : (x > 1 ? 0 : fadeOutFunc(x)); // Fades between 0.00 and 1.00

var thesin = (x) => Math.sin(decayF(x));
var lineImperfection = (x) => Math.sin(x * 1000) / 3;
var thesinx = (x) => x - thesin(x) / 60;

var menClasses = ["man1", "man2", "man3"];
// NOT USED YET: var meClass = "me";

export class PeopleSuperVisual3DProgressPower extends React.Component{
    constructor(props) {
        super(props)
        this.state = {
            viewportSize: {
                height: 150,
                width: 500
            },
            animPosition: 0 // We start to zero so the user can see a first animation and understands that this things is moving and will really show him the progress.
        }
    }

    componentDidMount() {
        this.checkViewportChanged();
        this.startAnimToProgress(this.props.progressPercentage);
    }

    componentWillUpdate(newProps) {
        this.checkViewportChanged();
        
        if(newProps.progressPercentage !== this.props.progressPercentage)
            this.startAnimToProgress(newProps.progressPercentage);
    }
    
    componentWillUnmount() {
        this.stopAnim();
    }
    
    startAnimToProgress(toProgress) {
        this.stopAnim();
        
        this.anim = new animjs.Anim(this.props.animSpeedMS, (t) => {
            this.setState({animPosition: t});
        }, animjs.getScaledEaseFunct(this.state.animPosition, toProgress, animjs.easeInOutSmooth)); // Anim from the current progress position to the new progress value.
    }
    
    stopAnim() {
        if(this.anim !== undefined) {
            this.anim.stop();
            this.anim = undefined;
        }
    }

    checkViewportChanged() {
        // If we now have access to the viewport (Probably an HTML Div)
        if(this.viewport !== undefined) {
            var actualVPSize = {
                width: this.viewport.clientWidth,
                height: this.viewport.clientHeight
            }

            if(actualVPSize.width !== this.state.viewportSize.width
               || actualVPSize.height !== this.state.viewportSize.height) {
                //console.log("View port update!");
                this.setState({ viewportSize: actualVPSize }); // This could cause an infinite render loop if the UI glitches
            }
        }
    }

    getStuffPosition() {
        var pos = {};

        // Size of the place
        pos.lineHeight = 7; // this.state.viewportSize.height; (New placeHeight)
        pos.placeWidth = this.state.viewportSize.width - (this.props.leftRightPadding * 2);
        pos.xScale = pos.placeWidth / this.props.maxTInViewport;
        pos.fadeOutZoneWidth = this.props.fadeOutEndT - 1; // Take the 1 - t length because we fade after 1.0
        
        pos.startX = this.props.leftRightPadding;
        pos.startY = (this.state.viewportSize.height / 2) - this.props.smallestManSize; // Kinf of a "v-center"

        // People resolution
        var peopleResolution = 0.02;
        if(pos.placeWidth < 400)
            peopleResolution = 0.04;
        else if(pos.placeWidth < 650)
            peopleResolution = 0.03;
            
        pos.ts = []; // T-Axis values
        for(var i = -1; i <= 1; i += peopleResolution) pos.ts.push(i); // Create ts according to resolution
        pos.meIndex = Math.round(pos.ts.length / 2);

        // sin functions
        pos.scaledSinX = (t) => thesinx(t) * pos.xScale + pos.startX; // This simply convert to parametric and adds perspective
        pos.scaledSinY = (t) => thesin(t) * pos.lineHeight + pos.startY;
        pos.scaleY = (unscaledY) => unscaledY * pos.lineHeight + pos.startY; // Where TD is an adjusted T that put more mens at the beginning and where t is a linear t.
        
        pos.leftFlagPos = {
            x: pos.scaledSinX(1) - 25,  // Just a little behind - Flags are at t=1 with perspective
            y: pos.scaledSinY(1) - 7 // Just a little farther
        }
        pos.rightFlagPos = {
            x: pos.scaledSinX(1) + 35, // Jsut a little after - Flags are at t=1 with perspective
            y: pos.scaledSinY(1) + 50 // Just a little closer
        }

        pos.tree1Pos = {
            x: pos.scaledSinX(0.20), // Jsut a little after - Flags are at t=1 with perspective
            y: pos.scaledSinY(0.20) - 20, // Just a little closer
            fSize: 40 // px
        }
        pos.tree2Pos = {
            x: pos.tree1Pos.x + 13, // Jsut a little after - Flags are at t=1 with perspective
            y: pos.tree1Pos.y - 5, // Just a little closer
            fSize: 38 // px
        }

        return pos;
    }
    
    render() {
        var pos = this.getStuffPosition();

        var myPos = null; // This will be the position info of the user so we can add an arrow over it.
        var people = pos.ts.map((t, i) => {
            var tt = t + this.state.animPosition; // tt is a t moved add the current progress percentage point
            if(tt < 0) return null; // This kills the men before 0
            var td = Math.pow(tt, 2); // Scale T over x^2 so the tt goes slower at the beginning and faster at the end

            // x of tha man
            var x = pos.scaledSinX(td); // Add the perspective to it!

            // y of tha man
            var unscaledY = thesin(td) + lineImperfection(t); // The line imperfection must move with the people! 
            var y = pos.scaleY(unscaledY);

            // Size and deepness
            var manScale = ((thesin(td) + 1) / 2) * this.props.manSizeVariation;
            var size = manScale + this.props.smallestManSize;
            var zIndex = Math.round(((unscaledY + 2) / 2) * this.props.zIndexVariation + this.props.zIndexBase);
            
            var icon = "fa fa-male";
            var manClass = menClasses[i % menClasses.length];
            var opacity = fadeOut((tt - 1) / pos.fadeOutZoneWidth); // Fade them out after tt>1.0

            if(i === pos.meIndex){
      	        manClass = "me";
                myPos = { manScale: manScale, x: x, y: y, opacity: opacity, zIndex: zIndex };
            }

            var lilManStyle = {
                position: "absolute", // Base                
      	        top: y + "px", 
                left: x + "px", 
                fontSize: size + "px",
                opacity: opacity,
                zIndex: zIndex
            };
            
    	    return <div key={i} className={cIf("lilman", manClass)} style={lilManStyle}>
      	        <i className={icon}></i>
            </div>
        });

        var mainDivStyle = {
            position: "relative",
            overflow: "hidden"
        };

        var pointer = null; // This is the arrow over the user's man
        if(myPos != null)
            pointer = <i className="fa fa-sort-desc me-pointer" style={{
                position: "absolute", // Base
      	        top: (myPos.y - (8 + (myPos.manScale / 2))) + "px", 
                left: (myPos.x + ((myPos.manScale / 2) + 5)) + "px",
                opacity: myPos.opacity,
                zIndex: myPos.zIndex
            }}></i>;
        
  	    return <div
                   className="people-supervisual-progress"
                   style={mainDivStyle}
                   ref={(el) => {this.viewport = el;}}
               >
    	    <i className="fa fa-tree tree1" style={{ position: "absolute", left: pos.tree1Pos.x, top: pos.tree1Pos.y, fontSize: pos.tree1Pos.fSize, zIndex: 2 }}></i>
            <i className="fa fa-tree tree2" style={{ position: "absolute", left: pos.tree2Pos.x, top: pos.tree2Pos.y, fontSize: pos.tree2Pos.fSize, zIndex: 1 }}></i>
            <i className="fa fa-flag-checkered flag-left" style={{ position: "absolute", left: pos.leftFlagPos.x, top: pos.leftFlagPos.y, zIndex: 1 }}></i>
            <i className="fa fa-flag-checkered flag-right" style={{ position: "absolute", left: pos.rightFlagPos.x, top: pos.rightFlagPos.y, zIndex: this.props.zIndexBase + this.props.zIndexVariation + 10 }}></i>
    	    {people}
            {pointer}
        </div>;
    }
}

PeopleSuperVisual3DProgressPower.propTypes = {
    progressPercentage: PT.number, // Progress percentage (0.00 - 1.00)
    animSpeedMS: PT.number,

    // Geometric Params and other
    leftRightPadding: PT.number,
    maxTInViewport: PT.number, // Max t (t as in a parametric equation yes...)
    fadeOutEndT: PT.number, // Max t (t as in a parametric equation yes...)
    manSizeVariation: PT.number, // px
    smallestManSize: PT.number, // px
    zIndexBase: PT.number, // Minimum zIndex of the men
    zIndexVariation: PT.number // zIndex variation of the men
};

PeopleSuperVisual3DProgressPower.defaultProps = {
    progressPercentage: 0.0,
    animSpeedMS: 3000,

    // Geo Params and other
    leftRightPadding: 18,
    maxTInViewport: 1.15, // Max t (t as in a parametric equation yes...)
    fadeOutEndT: 1.05, // Max t (t as in a parametric equation yes...)
    manSizeVariation: 8, // px
    smallestManSize: 32, // px
    
    zIndexBase: 10, // Minimum zIndex of the men
    zIndexVariation: 100 // zIndex variation of the men
};
